import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { baseURL, headers } from '@/v2/constants/requests'

const QUERY_KEY = ['SettingsProfile']

export const useSettingsProfile = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const res = await fetch(`${baseURL}/v2/rest/settings/profile`, {
        method: 'GET',
        headers,
      })
      if (!res.ok) {
        throw new Error("We couldn't load the profile settings")
      }
      return res.json()
    },
  })

  return { profile: data, isLoading, isError }
}

export const useUpdateProfile = () => {
  const queryClient = useQueryClient()

  const { mutateAsync: updateProfile, ...rest } = useMutation({
    mutationFn: async userData => {
      const res = await fetch(`${baseURL}/v2/rest/settings/profile`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify({ profile: userData }),
      })
      if (!res.ok) {
        const error = await res.json()
        throw new Error(error.errors || 'Could not update profile')
      }
      return res.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY })
      queryClient.invalidateQueries({ queryKey: ['User'] })
    },
  })

  return { updateProfile, ...rest }
}
